<script setup lang="ts"></script>
<template>
  <ConfirmDialog group="top-level" />
  <ConfirmDialog group="dirty-state" />
</template>
